import React, { useContext } from 'react'
import Slider from "react-slick";
import cls from 'classnames'
import { Global } from "../../App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FormattedMessage } from 'react-intl';
import { CusInput } from '../../Components/From/Input';
import { CusButton } from '../../Components/From/Button';
import Tool_CusCategory from '../../Components/Tools/Tool_CusCategory';

import './style.scss';
import { useRef, useState } from 'react';
import { useEffect } from 'react';

/**
 * 
 * @param {object} props 
 * @param {{ title: string, items: any[] }} props.items
 * @param {(item: any) => React.ReactNode} props.renderItem,
 * @param {() => React.ReactNode} props.renderTab
 */
const ScrollTabs = ({
  tabs,
  allTabs,
  items,
  renderItem,
  searchOnChange,
  isSwipe = false,
  searchPlaceholder,
  itemOnSelected,
  renderTab,
  menuType,
  menuTypeSwitch,
  openFilter,
  isFillFilter
}) => {
  const { globalState, dispatchGlobal } = useContext(Global);
  const slickRef = useRef()
  /** @type {React.RefObject<HTMLDivElement[]>} */
  const itemsRef = useRef([])
  /** @type {React.RefObject<HTMLDivElement>} */
  const bodyRef = useRef()
  /** @type {React.RefObject<'CLICK' | 'SCROLL'> } */
  const stateRef = useRef('SCROLL')

  const [state, setState] = useState({
    categoryPopupToggle: false,
    searchMsg: '',
    nextIdx: null
  })

  const settings = {
    swipeToSlide: true,
    centerMode: true,
    centerPadding: '0px',
    infinite: true,
    // speed: 0,
    // initialSlide: 0,
    slidesToShow: tabs.length < 5 ? tabs.length : 5,
    // centerPadding: 0,
    // infinite: true,
    focusOnSelect: true,
    accessibility: false,
    arrows: false,
    // swipe: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          centerMode: true,
          slidesToShow: tabs.length < 3 ? tabs.length : 3
        }
      }
    ],
    onSwipe: () => {
      isSwipe = true;
    },
    beforeChange: (oldIdx, nextIdx) => {
      if (stateRef.current === 'CLICK') {
        const tab = tabs[nextIdx]
        const itemIdx = items.findIndex(item => item.$tab === tab.value)
        console.log(nextIdx, tab, itemIdx)
        if (itemsRef.current[itemIdx] !== undefined) {
          const { y } = itemsRef.current[itemIdx].getBoundingClientRect()
          document.body.scrollTop = (document.body.scrollTop + y) - 60 - 42
        }
        setTimeout(() => {
          stateRef.current = 'SCROLL'
        })
        // 滑動分類標題列
      } else if (stateRef.current === 'SCROLL' && isSwipe) {
        const tab = tabs[nextIdx]
        const itemIdx = items.findIndex(item => item.$tab === tab.value)
        console.log(nextIdx, tab, itemIdx)
        if (itemsRef.current[itemIdx] !== undefined) {
          const { y } = itemsRef.current[itemIdx].getBoundingClientRect()
          document.body.scrollTop = (document.body.scrollTop + y) - 60 - 42
        }
      }
    }
  };

  useEffect(() => {
    if (state.nextIdx !== null && (state.nextIdx < tabs.length)) {
      const tab = tabs[state.nextIdx]
      const itemIdx = items.findIndex(item => item.$tab === tab.value)
      console.log(state.nextIdx, tab, itemIdx)

      if (itemsRef.current[itemIdx] !== undefined) {
        const { y } = itemsRef.current[itemIdx].getBoundingClientRect()
        document.body.scrollTop = (document.body.scrollTop + y) - 60 - 42
      }

      setTimeout(() => {
        stateRef.current = 'SCROLL'
      })
    }

    let timer
    const handleScroll = () => {
      if (stateRef.current !== 'CLICK') {
        if (timer !== undefined) {
          clearTimeout(timer)          
          timer = undefined
        }

        timer = setTimeout(() => {
          const findIndex = itemsRef.current.findIndex(item => {
            if (item) {
              const { y: targetY } = item.getBoundingClientRect()
              return targetY > 0
            }
          })

          if (items[findIndex] !== undefined) {
            const { $tab } = items[findIndex]
            const findTabIndex = tabs.findIndex(item => item.value === $tab)
            slickRef.current.slickGoTo(findTabIndex)
          }
        }, 200)
      }
    }
    window.document.body.addEventListener('scroll', handleScroll)

    return () => {
      window.document.body.removeEventListener('scroll', handleScroll)
    }
  }, [items, tabs, state.searchMsg, state.nextIdx])

  if (items.length === 0 && tabs.length === 0) {
    return null
  }

  return (
    <>
      <div className='ScrollTabs'>
        <div className='ScrollTabs__Tabs'>
          <div
            className='ScrollTabs__Tabs__Prev'
            onClick={() => {
              stateRef.current = 'CLICK'
              slickRef.current.slickPrev()
            }}
          >
            <a
              className={cls(['', 'icn', {
                btn_menu_pre__pc: globalState.device === 'pc',
                btn_menu_pre__mobile: globalState.device !== 'pc',
              }])}
            />
          </div>
          <div className='ScrollTabs__Tabs__Slider'>
            <Slider
              {...settings}
              ref={slickRef}
            >
              {tabs.map((e, index) => (
                <div
                  key={index}
                  className={'ScrollTabs__Tabs__Item'}
                  onClick={() => {
                    stateRef.current = 'CLICK'
                    slickRef.current.slickGoTo(index)
                  }}
                >
                  {(e.count > 0)?
                    <span>{e.title}({e.count})</span>
                    :
                    <span>{e.title}</span>}
                </div>
              ))}
            </Slider>
          </div>
          <div
            className='ScrollTabs__Tabs__Next'
            onClick={() => {
              stateRef.current = 'CLICK'
              slickRef.current.slickNext()
            }}
          >
            <a
              className={cls([
                '', 'icn', {
                  btn_menu_next__pc: globalState.device === 'pc',
                  btn_menu_next__mobile: globalState.device !== 'pc',
                }
              ])}
            />
          </div>
          <div className='ScrollTabs__Tabs__Input__Bar'>
            <div className='ScrollTabs__Tabs__Input__Bar__Icon d-inline-block align-middle mr-2'>
              <i className='icn ic_order_category__mobile'
                onClick={() => {
                  setState(curr => {
                    let newState = { ...curr };
                    newState.categoryPopupToggle = true;
                    return newState;
                  })
                }}
              />
            </div>
            <div className='ScrollTabs__Tabs__Input__Bar__Input d-inline-block ml-2 mr-2'>
              <CusInput
                className="w-100"
                icon={<i className="icn ic_order_search__mobile" />}
                maxLength={6}
                placeholder={searchPlaceholder}
                value={state.searchMsg}
                onChange={event => {
                  let val = event.target.value.trim();
                  if (searchOnChange) {
                    searchOnChange(val);
                  }
                  setState(curr => {
                    return {
                      ...curr,
                      nextIdx: null,
                      searchMsg: event.target.value
                    };
                  });
                }}
              />
            </div>
             <div className='ScrollTabs__Tabs__Input__Bar__Icon d-inline-block align-middle ml-2 mr-2'>
              {/*<i className={cls('icn',
                isFillFilter ? 'ic_order_fill_filter__mobile' : 'ic_order_filter__mobile')}
                onClick={() => {
                  if (openFilter) {
                    openFilter();
                  }
                }}
              /> */}
              <div onClick={() => {
                if (openFilter) {
                  openFilter();
                  setState(curr => {
                    return {
                      ...curr,
                      nextIdx: 0
                    };
                  });
                }
              }}
               className={isFillFilter? "filter_button-on":"filter_button"} style={{width:"46.5px", maxHeight:"50px"}}>
                <FormattedMessage id="page.filterbutton" />
              </div>
            </div>
            <div className='ScrollTabs__Tabs__Input__Bar__Icon d-inline-block align-middle ml-3'>
              <i className={cls('icn',
                menuType === 1 ? 'ic_order_list_menu__mobile' : 'ic_order_grid_menu__mobile'
              )}
                onClick={() => {
                  if (menuTypeSwitch) {
                    menuTypeSwitch();
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className={cls('ScrollTabs__Body', menuType === 1 ? 'row' : '')} ref={bodyRef}>
          {items.map((item, idx) => (
            <div
              className={menuType === 1 ? 'col-6 col-sm-4 p-1' : ''}
              key={idx}
              ref={ref => itemsRef.current[idx] = ref}
            >
              {renderItem && renderItem(item)}
            </div>
          ))}
        </div>
      </div>
      {/* 切換分類視窗 */}
      {(() => {
        if (!state.categoryPopupToggle) return null;
        return (
          <Tool_CusCategory
            categoryGroup={tabs}
            onClose={() => {
              setState(curr => {
                return {
                  ...curr,
                  categoryPopupToggle: false
                };
              });
            }}
            selectedItem={nextIdx => {
              itemOnSelected();
              setState(curr => {
                return {
                  ...curr,
                  searchMsg: '',
                  nextIdx
                };
              });
            }}
          />
        );
      })()}
    </>
  )
}


export default ScrollTabs